import { ArrowsClockwise } from '@phosphor-icons/react';
import { Button, Surface, Text } from '@shh/ui';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { appText } from '../i18n/app';

/**
 * A new version is only activated after consent – never mid-tap on the wall display. It is
 * looked for regularly and whenever the app comes back to the foreground.
 * Announced politely to screen readers.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    // Browsers only look for a new version on navigation – an app that stays open (wall display,
    // a tab kept for days) would never hear of it. Check every 30 minutes and on coming back.
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => void registration.update().catch(() => undefined);
      window.setInterval(check, 30 * 60_000);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') check();
      });
    },
  });

  if (!needRefresh) return null;
  return (
    <div role="status" className="fixed inset-x-0 bottom-0 z-50 px-gutter pb-safe">
      <Surface
        tone="raised"
        className="mx-auto flex max-w-narrow flex-wrap items-center gap-gap-md shadow-floating"
      >
        <Text className="flex-1">{appText.update}</Text>
        <Button variant="quiet" onPress={() => setNeedRefresh(false)}>
          {appText.later}
        </Button>
        <Button icon={ArrowsClockwise} onPress={() => void updateServiceWorker(true)}>
          {appText.refresh}
        </Button>
      </Surface>
    </div>
  );
}
